import { IStoreState } from 'state/rootReducer';

export const getUserInfo = ({ userInfo }: IStoreState) => ({
  permissions: userInfo.userData.permissions,
  unleash_permissions: userInfo.userData.unleashPermissions,
});
